import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchProfiles } from '../actions/profileActions';

export default function useProfiles() {
    const dispatch = useDispatch();
    const [fetchedId, setFetchedId] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const { profiles } = useSelector(
        ({ profile }) => profile
    );
    const companyInfo = useSelector(
        ({ companyInfo }) => companyInfo
    );

    useEffect(() => {
        if (!companyInfo.companyId) {
            return;
        }
        if (loading || fetchedId === companyInfo.companyId) {
            return;
        }
        const runFetchProfiles = async () => {
            setFetchedId(companyInfo.companyId);
            setLoading(true);
            setErrors([]);
            try {
                await dispatch(fetchProfiles(companyInfo.companyId));
                setLoading(false);
            } catch (error) {
                setFetchedId('');
                setLoading(false);
                setErrors([error]);
            }
        };
        runFetchProfiles();
    }, [loading]);

    return { profiles, errors, loading };
}
